import { render, staticRenderFns } from "./Closings.vue?vue&type=template&id=dd8124d0"
import script from "./Closings.vue?vue&type=script&lang=js"
export * from "./Closings.vue?vue&type=script&lang=js"
import style0 from "./Closings.vue?vue&type=style&index=0&id=dd8124d0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd8124d0')) {
      api.createRecord('dd8124d0', component.options)
    } else {
      api.reload('dd8124d0', component.options)
    }
    module.hot.accept("./Closings.vue?vue&type=template&id=dd8124d0", function () {
      api.rerender('dd8124d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Closings.vue"
export default component.exports